// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"ManageClients_listHeader__3DLtR","header":"ManageClients_header__1xIa5","clientTable":"ManageClients_clientTable__x62nt"};